// Layout - shared page layout wrapper with header and main content areas
// Implements US-0.2: Frontend Design System (Elevated Card Pattern)

import React from 'react';
import styles from './Layout.module.css';

/**
 * PROPS for Layout component
 * - children: Main page content
 * - header: Optional header content displayed above main content
 */
interface LayoutProps {
  children: React.ReactNode;
  header?: React.ReactNode;
}

/**
 * RENDER shared page layout structure
 * Provides consistent elevated card layout for all pages
 *
 * NOTE: Header is optional - pages can omit header for custom layouts
 * NOTE: Main content area always rendered for consistent spacing
 */
const Layout: React.FC<LayoutProps> = ({ children, header }) => {
  return (
    <div className={styles.container}>
      {/* RENDER header card if provided - enables page-specific headers */}
      {header && (
        <header className={styles.headerCard}>
          {header}
        </header>
      )}

      {/* RENDER main content card - consistent container for all pages */}
      <main className={styles.mainCard}>
        {children}
      </main>
    </div>
  );
};

export default Layout;
